import React from "react";

const FilterOptionWrapper = ({
    filter,
    index,
    selectedFilters,
    component,
    handleCheckboxClicked,
    isDate = false,
    children,
}) => {
    const getFilterOptionCheckbox = (filter, index) => {
        const focusAfterClick = filter.type === "Input";
        return (
            <div className="filter-items-options-header border-bottom">
                <div className="checkbox-wrapper-input filter-checker-btn">
                    <input
                        onChange={() => {
                            handleCheckboxClicked(
                                filter.name,
                                "",
                                isDate,
                                focusAfterClick ? index : null
                            );
                        }}
                        type="checkbox"
                        className="checkbox-element"
                        id={`${component}-checkbox-filter-${index}`}
                        data-filter={`${component}-filter-content-${index}`}
                        checked={
                            (selectedFilters && selectedFilters[filter.name]) ||
                            ""
                        }
                    />
                    <label
                        id={`${component}-checkbox-${index}`}
                        htmlFor={`${component}-checkbox-filter-${index}`}
                    >
                        {filter.label}
                    </label>
                </div>
            </div>
        );
    };
    return (
        <>
            <div className="filter-items-options">
                {getFilterOptionCheckbox(filter, index)}
                <div
                    className={`filter-items-options-content ${
                        selectedFilters &&
                        selectedFilters[filter.name] &&
                        "show"
                    }`}
                    id={`${component}-filter-content-${index}`}
                >
                    {children}
                </div>
            </div>
        </>
    );
};

export default FilterOptionWrapper;
